export default __webpack_public_path__ + "static/media/step2.496a055b.png";